export interface IContact {
	email?: string;
	name?: string;
	phone?: string;
	tags?: string[];
}
